import uiReducer, { uiSlice } from "./ui/ui.slice"
import memberReducer, { memberSlice } from "./member/member.slice"
import apiReducer, { apiSlice } from "./apis/api.slice"
import formReducer, { formSlice } from "@/store/form/form.slice"

export default {
  [memberSlice.name]: memberReducer,
  [uiSlice.name]: uiReducer,
  [apiSlice.reducerPath]: apiReducer,
  [formSlice.name]: formReducer,
}
